Librarian.SearchResultItem = new Class({
    Extends: Librarian.CartDraggable,
    Implements: [Options],
    Binds: ["render", "previewItem", "openItem", "handleCartCheck"],
    className: "search-result",

    options: {
        maxHighlights: 2,
        view: -1,
        parent: null,
        showMoreCount: 5
    },

    resultHtml: "\
    <div class='{{class}}-item'> \
        <div class='{{class}}-thumbnail'> \
            <img class='{{class}}-thumbnail-image {{thumbnailClass}}' src='{{thumbnail}}' /> \
            <div class='{{class}}-cart-state ico-cart-added' style='display: none;'></div> \
            {{#if isThumbnailView}}<div class='{{class}}-flags {{flagLocation}}' style='display: none;'></div>{{/if}} \
        </div> \
        <div class='{{class}}-info'> \
            <div class='{{class}}-name'>{{name}} {{#if isSlide}} <span class='separator'>|</span> Page: {{slideNumber}}{{/if}} \
            {{#unless isThumbnailView}}<div class='{{class}}-flags' style='display: none;'></div>{{/unless}} \
            </div> \
            <div class='{{class}}-misc'> \
                <span class='{{class}}-desc'>File Description: {{desc}}</span> \
                <br> \
                <span class='{{class}}-paths'>File Location: \<a class='{{class}}-path' href='javascript:void(0);'>{{path}}</a> \
                {{#if hasOtherPaths}} \
                    <span class='{{class}}-more-paths-trigger'> \
                    (<a href='javascript:void(0);'>{{pathCount}} more...</a>) \
                    </span> \
                {{/if}} \
                </span> \
                <span>|</span> \
                <span class='{{class}}-last-modified'>Last Modified: {{lastModDate}}</span> \
                <div class='{{class}}-more-paths'> \
                    Other Locations: \
                    {{#each otherPaths}}\
                        <a href='javascript:void(0);' class='{{../class}}-path'>{{this}}</a>  \
                        <span class='separator'></span> \
                    {{/each}} \
                </div> \
            </div> \
            {{#if showStats}} \
                <div class='{{class}}-stats'> \
                    <span>Previews: </span> \
                    <span class='{{class}}-preview-stat' title='Previews'>{{previews}}</span> \
                    <span>|</span> \
                    <span>Downloads: </span> \
                    <span class='{{class}}-download-stat' title='Downloads'>{{downloads}}</span> \
                    <span>|</span> \
                    <span>Shares: </span> \
                    <span class='{{class}}-share-stat' title='Shares'>{{shares}}</span> \
                </div> \
            {{/if}} \
            <div class='{{class}}-feedback'> \
                <span class='{{class}}-rating-stars'>{{#drawAvgRatingStars avgRating}}{{/drawAvgRatingStars}} </span> \
                <span class='{{class}}-rating-score'>Rating: {{avgRating}}</span> \
                <span class='{{class}}-review-count'>- <a href='javascript:void(0);'>{{ratingCount}}</a></span> \
            </div> \
            <div class='{{class}}-description'></div> \
            <div class='{{class}}-highlights'></div> \
            <div class='{{class}}-missing'></div> \
        </div> \
    </div> \
    ",

    lastQuery: null,
    hoverMenu: null,

    initialize: function (options, parent) {
        this.setOptions(options);
        this.lastQuery = parent.lastQuery;
        this.hoverMenu = parent.hoverMenu;
        this.itemClassName = this.className;
        this.tokenizedQuery = parent.data.tokenizedQuery;

        Handlebars.registerHelper("drawAvgRatingStars", this.drawAvgRatingStars);
        this.resultTemplate = Handlebars.compile(this.resultHtml);
    },

    drawAvgRatingStars: function (rating) {
        var html = [];
        // Cap the rating to max ratings
        rating = Math.min(rating, Librarian.preview.ratingMaxStars);
        var fullStars = Math.floor(rating),
            halfStars = Math.ceil(rating) - fullStars,
            emptyStars = Librarian.preview.ratingMaxStars - fullStars - halfStars;

        for (var i = fullStars; i--;)
            html.push("<span class='ratings-rate-star ratings-rate-star-on'></span>");

        for (var i = halfStars; i--;)
            html.push("<span class='ratings-rate-star ratings-rate-half-star'></span>");

        for (var i = emptyStars; i--;)
            html.push("<span class='ratings-rate-star'></span>");

        return new Handlebars.SafeString(html.join(''));
    },

    getCompatibleContentInfo: function (contentInfo) {
        var libContentInfo = Object.toLowerKeys(contentInfo);
        libContentInfo.contentname = contentInfo.name;

        if (contentInfo.parentContentType == Librarian.contentType.file) {
            libContentInfo.fileid = contentInfo.parentContentId;
        }

        if (libContentInfo.slidenumber == -1) {
            libContentInfo.slidenumber = 0;
        }
        Object.merge(libContentInfo, Librarian.Utils.getFromContent(libContentInfo));
        Librarian.Utils.prepareItemData(libContentInfo);

        return libContentInfo;
    },

    render: function () {
        var contentInfo = this.options.data;
        var stats = contentInfo.statsInfo || [];
        var index = this.options.index;
        var self = this;
        var resultEl = this.resultEl = new Element("div", {
            "class": this.className + "-item-cont"
        });

        if (this.isFeatured(contentInfo))
            resultEl.addClass("featured");

        var highlights = this.getHighlights(contentInfo.highlights);

        var missingText = [];
        if (this.lastQuery) {
            var missing = this.getMissing(this.lastQuery, highlights);
            missingText = missing.map(function (term) {
                return "<strike>" + term + "</strike>";
            });
        }

        var extension = Librarian.Utils.getExtension(contentInfo.name);
        if (extension.trim().length == 0) {
            if (contentInfo.contentType == Librarian.contentType.globalFavorite) {
                extension = "vpres";
            }
        }

        var thumbnail;
        var thumbnailClass = "";

        if (this.options.view === Librarian.SearchResult.views.thumbnail) {
            if (extension == "wiz") {
                thumbnail = Librarian.path.getFileTypeIconsPath("v2") + "Wizard_Thumbnail.png";
            }
            else {
                thumbnail = Librarian.Utils.getThumbnailUrl("sm", {
                    thumbnailid: contentInfo.thumbnailId,
                    ext: extension
                });
            }
        } else {
            thumbnail = Librarian.Utils.getFileTypeIcon(extension);
            thumbnailClass = this.className + "-file-type-icon";
        }

        var allPaths = contentInfo.categories.map(function(info) {
            return info.catPath;
        });

        var resultHtml = this.resultTemplate({
            "class": this.className,
            "thumbnailClass": thumbnailClass,
            "name": contentInfo.attributes[Librarian.elasticSearch.resultNameOverridemeta] || contentInfo.name,
            "desc": contentInfo.description || "No description available",
            "path": allPaths.shift(),
            "pathCount": allPaths.length,
            "hasOtherPaths": allPaths.length > 0,
            "otherPaths": allPaths,
            "size": contentInfo.fileSize + " KB",
            "avgRating": parseFloat(contentInfo.avgRating.toFixed(1)),
            "ratingCount": contentInfo.ratingCount + " " + Librarian.Lang.getPluralString("review", contentInfo.ratingCount),
            "lastModDate": Librarian.Utils.getDateValue(contentInfo.lastModDate),
            "recordDate": Librarian.Utils.getDateValue(contentInfo.recordDate),
            "missing": missingText.join(", "),
            "thumbnail": thumbnail,
            "slideNumber": contentInfo.slideNumber,
            "isSlide": contentInfo.slideNumber > 0,
            "flagLocation": Librarian.Utils.getFlaggingLocation(Librarian.flagging.location),
            "isThumbnailView": this.options.view === Librarian.SearchResult.views.thumbnail,
            "showStats": Librarian.elasticSearch.stats && stats,
            "previews": stats.previews,
            "downloads": stats.downloads,
            "shares": stats.shares
        });

        resultEl.set("html", resultHtml);

        var allowHighlights = this.isHighlightAllowed(contentInfo);
        if (allowHighlights && highlights.length) {
            var highlightsEl = resultEl.getElement("." + this.className + "-highlights");
            highlightsEl.grab(this.renderHighlights(contentInfo, highlights, missing));

            var missingEl = resultEl.getElement("." + this.className + "-missing");
            missingEl.grab(this.renderMissing(highlights));
        }
        else {
            // Show the description instead
            var descriptionEl = resultEl.getElement("." + this.className + "-description");
            Librarian.Utils.setElementValue(descriptionEl, contentInfo.description);
        }

        var previewTriggers = ["." + this.className + "-name", "." + this.className + "-thumbnail"];
        var nameEl = resultEl.getElements(previewTriggers.join(","));
        if (nameEl) {
            var ext = Librarian.Utils.getExtension(contentInfo.name);
            if (ext == "rss") {
                nameEl.addEvent("click", this.openItem);
            }
            else if ((!contentInfo.slideid || contentInfo.slideid <= 0) && (Librarian.search.openFileLocation == true))
                nameEl.addEvent("click", this.openItem);
            else 
                nameEl.addEvent("click", this.previewItem);
        }


        var cartStateEl = this.cartStateEl = resultEl.getElement("." + this.className + "-cart-state");
        cartStateEl.addOnClick(function (e) {
            e.stop();
            self.handleCartCheck();          
        });
        this.updateCartState();

        var thumbnailEl = resultEl.getElement("." + this.className + "-thumbnail");
        if (this.options.view === Librarian.SearchResult.views.thumbnail) {
            thumbnailEl.addEvent("mouseover", function () {
                self.getContentInfo(contentInfo, function (info) {
                    self.hoverMenu.index = index;

                    var isCategory = true;
                    if (info.contenttype == Librarian.contentType.slide || info.slideInfo)
                        isCategory = false;

                    var type;
                    if (info.groupid > 0) {
                        if (typeof info.eventcount == "number")
                            type = Librarian.hoverMenuTypes.event;
                        else
                            type = Librarian.hoverMenuTypes.globalFavorite;
                    }
                    else if (info.presid > 0)
                        type = Librarian.hoverMenuTypes.myFavorite;
                    else if (info.eventid > 0)
                        type = Librarian.hoverMenuTypes.event;
                    else
                        type = Librarian.hoverMenuTypes.file;

                    self.hoverMenu.onMouseOver(thumbnailEl, isCategory, type, info, false, null);
                });
            });
            thumbnailEl.addEvent("mouseout", function () {
                self.hoverMenu.onMouseOut();
            });

            this.initClickAndDrag(thumbnailEl);
        }

        var pathEl = resultEl.getElements("." + this.className + "-path");
        if (pathEl) {
            pathEl.addEvent("click", function (e) {
                var searchPageEl = $("search-result-page");
                if (searchPageEl) {
                    searchPageEl.hide();
                }

                // Get the path text and remove trailing slash if it exists
                var path = this.get("text").replace(/\/$/, "");

                Library.loadLibraryTab();
                Librarian.Utils.loadCategoryByPath(path);
            });
        }

        var reviewsEl = resultEl.getElement("." + this.className + "-review-count");
        if (reviewsEl) {
            reviewsEl.addEvent("click", function () {
                self.getContentInfo(contentInfo, function (info) {
                    var viewRatingsWindow = new Librarian.ViewRatingsWindow({
                        itemType: contentInfo.contentType == Librarian.contentType.slide ? "slide" : "file",
                        itemData: info
                    });
                    viewRatingsWindow.show();
                });
            });
        }

        var morePathsTriggerEl = resultEl.getElement("." + this.className + "-more-paths-trigger");
        if (morePathsTriggerEl) {
            morePathsTriggerEl.addEvent("click", function () {
                morePathsTriggerEl.hide();
                var morePathsEl = resultEl.getElement("." + self.className + "-more-paths");
                morePathsEl.show();
            });
        }

        var flagsEl = this.flags = resultEl.getElement("." + this.className + "-flags");
        if (Librarian.flagging.enabled && Librarian.flagging.showOnTileList) {
            this.renderFlags(contentInfo);
        }


        return resultEl;

    },

    initClickAndDrag: function (thumbnailEl) {
        var imageEl = thumbnailEl.getElement("." + this.className + "-thumbnail-image");

        imageEl.tileItem = this;

        imageEl.addEvent("mousedown", this.onDragStart)
           .addEvent("touchstart", this.onDragStart)
           .addEvent("mouseup", this.onDragEnd)
           .addEvent("touchend", this.onDragEnd)
           .addEvent("mouseout", this.onDragItem)
           .addEvent("touchmove", this.onDragItem);
    },

    updateCartState: function (show) {
        var libContentInfo = this.getCompatibleContentInfo(this.options.data);
        var isInCart = Librarian.userCart.isInCart(libContentInfo);
        if (show !== undefined) {
            isInCart = show;
        }

        if (isInCart) {
            this.cartStateEl.show();
        } else {
            this.cartStateEl.hide();
        }
    },

    renderHighlights: function (contentInfo, allHighlights, missing) {
        var self = this;
        var relevantHighlights = this.getRelevantHighlights(this.lastQuery, allHighlights, missing, this.options.maxHighlights);
        var highlights = relevantHighlights.relevantHighlights;
        var otherHighlights = relevantHighlights.otherHighlights;
        var highlightsEl = new Element("div");

        Array.each(highlights, function (highlight, index) {
            var highlightEl = self.renderHighlight(highlight, contentInfo);

            highlightsEl.grab(highlightEl);

            if ((highlights.length - 1) !== index) {
                highlightEl.appendText("...");
            }
        });

        if (otherHighlights != null && otherHighlights.length > 0) {
            highlightsEl.getLast().appendText("...");

            var showAllEl = new Element("a", {
                "class": "show-more",
                text: "Show More",
                href: "javascript:void(0)"
            });

            showAllEl.addEvent("click", function () {
                // Show next 10 siblings
                var otherHighlights = this.getAllNext().slice(0, self.options.showMore);

                if (otherHighlights.length > 0) {
                    new Elements(otherHighlights).show("inline");
                    otherHighlights.getLast().grab(this, "after");
                }

                otherHighlights = this.getAllNext().slice(0, self.options.showMore);
                if (otherHighlights.length === 0) {
                    this.hide();
                }
            });

            highlightsEl.grab(showAllEl);

            Array.each(otherHighlights, function (highlight, index) {
                var highlightEl = self.renderHighlight(highlight, contentInfo);
                highlightEl.hide();

                highlightsEl.grab(highlightEl);

                if ((otherHighlights.length - 1) != index) {
                    highlightEl.appendText("...");
                }
            });
        }

        return highlightsEl;
    },

    renderHighlight: function (highlight, contentInfo) {
        var self = this;
        var highlightText = Librarian.Utils.escapeHtml(highlight.highlightText);
        highlightText = highlightText.replace(/&lt;strong&gt;/g, "<strong>").replace(/&lt;\/strong&gt;/g, "</strong>");

        var highlightEl = new Element("span", {
            "html": highlightText
        });

        var highlightTermsEl = highlightEl.getElements("strong");
        highlightTermsEl.addEvent("click", function () {
            var contentId = contentInfo.contentId;
            var contentType = contentInfo.contentType;
            var parentContentId = contentInfo.parentContentId;
            var parentContentType = parentContentId > 0 ? contentInfo.parentContentType : null;

            if (highlight.contentId > 0) {
                contentId = highlight.contentId;
                contentType = highlight.contentType;

                if (parentContentId < 0) {
                    parentContentId = contentInfo.contentId;
                    parentContentType = contentInfo.contentType;
                }
            }

            var contentDetails = {
                contentId: contentId,
                contentType: contentType,
                parentContentType: parentContentType,
                parentContentId: parentContentId,
                slideNumber: highlight.slideNumber || contentInfo.slideNumber,
                name: contentInfo.name,
                contentInfo: highlight.contentInfo
            };

            self.getContentInfo(contentDetails, function (info) {
                highlight.contentInfo = info;

                var startTime = (/^StartTime: (\d+)/).exec(highlight.slideDescription);
                if (startTime != null) {
                    info.starttime = parseInt(startTime[1]);
                }
                Librarian.PreviewWindow.openPreviewWindow(info);
            });
        });

        return highlightEl;
    },

    renderMissing: function (highlights) {
        var missingContEl = new Element("div");
        var missing = this.getMissing(this.lastQuery, highlights);

        if (missing.length > 0) {
            missingContEl.set("text", "Missing: ");
        }

        Array.each(missing, function (term, index) {
            var missingEl = new Element("strike", {
                text: term
            });

            missingContEl.grab(missingEl);

            if ((missing.length - 1) != index) {
                missingContEl.grab(new Element("span", { text: ", " }));
            }
        });

        return missingContEl;
    },

    getContentInfo: function (contentInfo, callback) {
        var self = this;

        if (contentInfo.contentInfo != null) {
            callback(contentInfo.contentInfo);
        } else {
            var url;
            switch (contentInfo.contentType) {
                case Librarian.contentType.file:
                    url = Librarian.path.getMethodUrl("getfi") + "&fid=" + contentInfo.contentId + "&out=ljson&fvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];
                    break;
                case Librarian.contentType.slide:
                    if (contentInfo.parentContentType == Librarian.contentType.globalFavorite)
                        url = Librarian.path.getMethodUrl("getgslides") + "&gid=" + contentInfo.parentContentId + "&out=ljson&gvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.GROUPS];
                    else
                        url = Librarian.path.getMethodUrl("getslides") + "&fname=" + encodeURIComponent(contentInfo.name) + "&out=ljson&fvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];
                    break;
                case Librarian.contentType.globalFavorite:
                    url = Librarian.path.getMethodUrl("getcgi") + "&gid=" + contentInfo.contentId + "&out=ljson&gvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.GROUPS];
                    break;
            }



            if (url != null) {
                var request = new Librarian.Request.JSON({
                    url: url,
                    onSuccess: function (json) {
                        if (contentInfo.contentType == Librarian.contentType.slide) {
                            if (json.slides) {
                                json.fileinfo.slideInfo = json.slides[contentInfo.slideNumber - 1]; 
                                json = json.fileinfo;
                                json.slidenumber = contentInfo.slideNumber;
                            }
                                                      
                            if (json.items) {
                                json.groupinfo.slideInfo = json.items[contentInfo.slideNumber - 1];
                                json = json.groupinfo;
                            }

                          
                        }

                        Librarian.Utils.prepareItemData(json);
                        self.data = json;
                        contentInfo.contentInfo = json;

                        //Extra check for cases when slide number is not in the json
                        if (contentInfo.slideNumber != json.slideNumber)
                            contentInfo.contentInfo.slideNumber = contentInfo.slideNumber;

                        if (callback != null) {
                            callback(json);
                        }
                    }
                });
                request.send();
            }
        }
    },

    isHighlightAllowed: function(contentInfo) {
        var ext = Librarian.Utils.getExtensionFromData(contentInfo);

        if (Librarian.elasticSearch.disableHighlightExtensions.contains(ext))
            return false;

        return true;
    },

    getHighlights: function (searchHighlights) {
        var highlights = [];

        var addHighlight = function(highlight, key, parent) {
            if (typeOf(highlight) === "array") {
                Array.each(highlight, function(highlightItem) {
                    addHighlight(highlightItem, key, parent);
                });
            }
            else if (typeOf(highlight) === "object") {
                Object.each(highlight, function(highlightVal, highlightKey) {
                    // Don't include featured keywords in highlights
                    if (highlightKey == Librarian.elasticSearch.featuredKeywordsName)
                        return;

                    if (key === "attributes") {
                        addHighlight(highlightKey + ": " + highlightVal, "attributes", parent);
                    } else {
                        addHighlight(highlightVal, highlightKey, highlight);
                    }
                });
            }
            else {
                if (["text", "text.synonyms", "keywords", "description", "name", "notes", "attributes"].contains(key)) {
                    var highlightsInfo = typeOf(parent) === "object" ? Object.clone(parent) : {};
                    highlightsInfo.highlightText = highlight;
                    highlights.push(highlightsInfo);
                }
            }
        }

        Object.each(searchHighlights, addHighlight);

        return highlights;
    },

    isFeatured: function(contentInfo) {
        if (contentInfo.attributes && contentInfo.attributes[Librarian.elasticSearch.featuredFileMeta] == "true")
            return true;

        var highlights = contentInfo.highlights;
        if (!highlights)
            return false;

        var attributes = highlights.attributes;

        return attributes && attributes.hasOwnProperty(Librarian.elasticSearch.featuredKeywordsName);
    },

    getMissing: function (searchQuery, highlights) {
        var self = this;
        var allTerms = searchQuery.searchTerms != null ? searchQuery.searchTerms.allSearchTerms : [];
        var missing = [];

        var allHighlights = highlights.map(function (highlight) { return highlight.highlightText }).join("").toLowerCase();
        allHighlights = allHighlights.replaceAll("<strong>", "").replaceAll("</strong>", "").toLowerCase();

        Array.each(allTerms, function (term) {
            if (term == null || term.length === 0) {
                return;
            }

            var queryTerm = Librarian.SearchResult.cleanUpSearchTerm(term);
            var tokenizedTerm = Librarian.SearchResult.cleanUpSearchTerm(self.tokenizedQuery[term]);

            if (!(allHighlights.contains(queryTerm) || allHighlights.contains(tokenizedTerm))) {
                missing.push(queryTerm);
            }
        });

        return missing;
    },

    getRelevantHighlights: function (searchQuery, highlights, missing, top) {
        if (highlights.length <= top) {
            return {
                relevantHighlights: highlights,
                otherHighlights: []
            }
        }

        var allTerms = searchQuery.searchTerms != null ? searchQuery.searchTerms.allSearchTerms : [];
        var foundTerms = allTerms.filter(function (term) {
            return !missing.contains(term);
        });
        var relevantHighlights = [];
        var unusedHighlights = Array.clone(highlights);

        for (var i = 0, len = highlights.length; i < len; i++) {
            var highlight = highlights[i].highlightText.toLowerCase();

            var foundCount = foundTerms.length;
            var isRelevant = false;

            while (foundCount--) {
                if (highlight.contains(foundTerms[foundCount].toLowerCase())) {
                    foundTerms.splice(foundCount, 1);
                    isRelevant = true;
                }
            }

            if (isRelevant) {
                relevantHighlights.push(highlights[i]);
                unusedHighlights[i] = null;
            }

            if (foundTerms.length === 0) {
                break;
            }

            if (relevantHighlights.length === top) {
                break;
            }
        }

        unusedHighlights = unusedHighlights.clean();

        if (relevantHighlights.length < top && unusedHighlights.length > 0) {
            var short = top - relevantHighlights.length;
            var shortHighlights = unusedHighlights.splice(0, Math.min(short, unusedHighlights.length));
            if (shortHighlights != null && shortHighlights.length > 0) {
                relevantHighlights = relevantHighlights.concat(shortHighlights);
            }

        }

        return {
            relevantHighlights: relevantHighlights,
            otherHighlights: unusedHighlights          
        }
    },

    previewItem: function() {
        this.getContentInfo(this.options.data, function (info) {
            Librarian.PreviewWindow.openPreviewWindow(info);
        });
    },

    openItem: function() {
        var self = this;

        this.getContentInfo(this.options.data, function (info) {
            // Get tree info
            var tree = Library.getTreeByType(info.cattype, null, info.prestype);

            // If there is no tree, bail
            if (!tree)
                self.previewItem();
            Librarian.Utils.getPath(info, function(path) {
                if (path != null) {
                    Librarian.Utils.selectTreeNodeByPath(tree, path);
                    Library.loadLibraryTab();
                }
                // If the path wasn't found, fall back
                else {
                    self.previewItem();
                }
            }.bind(this));
        });
    },

    onDrop: function(e) {
        this.handleCartCheck();
    },

    onItemClick: function (e) {
        e.stop();

        var data = this.data;

        // If this is a file, however
        if (data.fileid || data.groupid || data.presid) {
            // And the correct item id, based on its type
            if (data.fileid) {
                data.type = Librarian.catType.file;
            }
            if (data.groupid) {
                data.type = Librarian.catType.globalFavorite;
            }
            if (data.presid) {
                data.type = Librarian.catType.myFavorite;
            }
        }

        // Send favorite type if we're currently looking at a SlideShow type
        var tree = Library.getTreeByType(data.type, initializer.tab, data.prestype);

        // If there is no tree, bail
        if (!tree)
            return false;

        Librarian.Utils.getPath(this.data, function(path) {
            if (path != null)
                Library.loadLibraryTab();
                Librarian.Utils.selectTreeNodeByPath(tree, path);
        });
    },

    handleCartCheck: function () {
        if (!Librarian.userCart)
            return;

        var self = this;
        // If we have slide information then add the slide to the cart instead of the file
        if (this.data && this.data.slideInfo)
            this.data = this.data.slideInfo;

        var isInCart = Librarian.userCart.isInCart(this.data);
        var type;

        // Remove
        if (isInCart) {
            Librarian.userCart.removeFromCart(this.data, false, null, true, null, function () {
                type = Librarian.cartNotificationTypes.removed;
                self.updateCartState(false);

            }.bind(this));
        }
        // Add to cart
        else {
            var added = Librarian.userCart.addToCart(this.data, false, true);
            type = Librarian.cartNotificationTypes.added;
            this.updateCartState(true);
        }


        Librarian.Cart.onChange();
        Librarian.Utils.showCartNotification(this.data, type, true);
    },

    renderFlags: function(contentInfo) {
        if (this.flags)
            this.flags.empty();

        this.flags.show("inline-block");
        var flagClasses = Librarian.Utils.getFlaggingClasses(contentInfo);
        for (var i = 0, len = flagClasses.length; i < len; i++) {
            var tooltip = null;
            var flagText = "";
            var hasExpired = null;
            if (flagClasses[i].contains("expired-flag")) {
                hasExpired = true;
                flag = flagClasses[i];
                tooltip = Librarian.Lang.getString("expired_content");
                flagText = Librarian.Lang.getString("expired_content_flag");
            }
            if (flagClasses[i].contains("viewonly-flag")) {
                tooltip = Librarian.Lang.getString("viewonly_content");
                flagText = Librarian.Lang.getString("viewonly_content_flag");
            }
            if (flagClasses[i].contains("nda-flag")) {
                tooltip = Librarian.Lang.getString("nda_content_tooltip");
                flagText = Librarian.Lang.getString("nda_content");
            }

            var internalTooltip = function () {
                if (Librarian.Lang.getString("internal_flag_tooltip") != "internal_flag_tooltip")
                    return Librarian.Lang.getString("internal_flag_tooltip");
                else
                    return "Internal Content";
            }

            if (flagClasses[i].contains("internal-flag")) {
                tooltip = internalTooltip();
                flagText = Librarian.Lang.getString("internal_content");
            }
            if (flagClasses[i].contains("new-content-flag")) {
                isInternal = true;
                tooltip = "Recently Added Content";
                flagText = Librarian.Lang.getString("new_content");
            }

            new Element("span", {
                "class": "content-flag " + flagClasses[i],
                "title": tooltip,
                text: flagText
            }).injectInside(this.flags);
        }
    },


});


Librarian.SearchResult = new Class({
    Binds: ["render", "renderSearchResult", "goToPage", "updateCartCheckBoxes"],

    className: "search-result",
    Implements: Options,

    options: {
        maxHighlights: 2,
        pagesToDisplay: 10,
        containerEl: null,
        showPagination: true,
        showSort: true,
        view: -1
    },

    currentPage: 1,
    totalPages: 1,
    lastQuery: null,

    items: [],

    resultPageHtml: "\
        {{#if showHeader}} \
        <div class='{{class}}-bucket-label'> \
            <span>{{name}}</span> \
            <span class='{{class}}-bucket-view-all'>View All &nbsp; ></span> \
        </div>\
        {{/if}} \
        <div class='{{class}}'> \
            <div class='{{class}}-sort-cont'></div>\
            <div class='{{class}}-page-info-cont'></div>\
            <div class='{{class}}-items-cont'></div>\
            {{#if showPagination}}<div class='{{class}}-pagination-cont'></div>{{/if}}\
        </div> \
    ",

    pageInfoHtml: "\
        {{#if showPagination}} \
            Page <span class='{{class}}-current-page'>{{currentPage}}</span> of <span class='{{class}}-last-page'>{{totalPages}}</span> ({{total}}) \
        {{else}} \
            {{total}} \
        {{/if}} \
    ",

    sortHtml: "\
        Sort By \
        <select class='{{class}}-sort-input'> \
        {{#each sort}} \
            <option value='{{value}}'{{#if selected}}selected='selected'{{/if}}>{{label}}</option> \
        {{/each}} \
        </select> \
    ",

    paginationHtml: "\
        <div class='{{class}}-navigation'> \
                <span class='{{class}}-to-previous ico-previous'></span> \
                <span class='{{class}}-nav-text'>Search result pages</span> \
                <span class='{{class}}-to-next ico-next'></span> \
        </div> \
        <div class='{{class}}-pages'> \
                <span class='{{class}}-previous'>Previous</span> \
            <span class='{{class}}-pages'>{{#drawPageNumbers pageInfo}}{{/drawPageNumbers}} </span> \
                <span class='{{class}}-next'>Next</span> \
        </div> \
    ",

    typeFilterHtml: "\
        <ul class='{{class}}-type-bar-controls'> \
        {{#objEach types}} \
            <li class='{{../class}}-type' id='{{id}}'> \
                <span title='{{getLangString name}}'>{{getLangString name}}</span> \
            </li> \
        {{/objEach}} \
        </ul> \
    ",

    bucketHtml: "\
        <div class='{{class}}-bucket-label'>{{label}}</div> \
        <div class='{{class}}-bucket-results'></div> \
    ",

    resultTemplate: null,

    initialize: function (options) {
        this.setOptions(options);

        Handlebars.registerHelper("drawPageNumbers", this.drawPageNumbers);
        Handlebars.registerHelper("getLangString", Librarian.Lang.getString);
        Handlebars.registerHelper("objEach", function (context, options) {
            var ret = "";

            Object.each(context, function (val, key) {
                val.id = key;
                ret = ret + options.fn(val);
            });

            return ret;
        });

        this.resultPageHtml = Handlebars.compile(this.resultPageHtml);
        this.emptyResultPageHtml = Librarian.SearchResult.emptyResultPageHtml;
        this.pageInfoTemplate = Handlebars.compile(this.pageInfoHtml);
        this.paginationTemplate = Handlebars.compile(this.paginationHtml);
        this.typeFilterTemplate = Handlebars.compile(this.typeFilterHtml);
        this.bucketTemplate = Handlebars.compile(this.bucketHtml);
        this.sortTemplate = Handlebars.compile(this.sortHtml);
    },

    initHoverMenu: function () {
        this.destroyHoverMenu();

        this.hoverMenu = new Librarian.HoverMenu({
            menuContainer: "tileListWrapper_tileMenu",
            dropDownContainer: "tileMenuDropDown",
            dropDownListContainer: "tileMenuList",
            dropDownTrigger: "cogDropDown",
            menuIdPrefix: "tileListWrapper_tileMenu",
            isInCart: false
        }, Library.getTileListMenuItems(), Library.getTileListDropDownItems(), this);
    },

    destroyHoverMenu: function () {
        if (this.hoverMenu) {
            this.hoverMenu.destroy();
            this.hoverMenu = null;
        }
    },

    drawPageNumbers: function() {
        var pagesToDisplay = this.pagesToDisplay;
        var currentPage = this.currentPage;
        var totalPages = this.totalPages;

        var setNumber = Math.floor(currentPage / pagesToDisplay);
        var initialNumber = setNumber * pagesToDisplay;
        var finalNumber = Math.min((initialNumber + pagesToDisplay), totalPages);

        var html = [];
        for (var i = Math.max(initialNumber, 1); i <= finalNumber; i++) {
            var pageNumberEl = new Element("span", {
                "class": this.class + "-page-number",
                "text": i
            });

            if (i === currentPage) {
                pageNumberEl.addClass("current-page");
            }

            html.push(pageNumberEl.outerHTML);
        }

        return new Handlebars.SafeString(html.join(''));
    },

    render: function (data) {
        if (this.options.view == Librarian.SearchResult.views.thumbnail) {
            this.initHoverMenu();
        }
        else {
            this.destroyHoverMenu();
        }

        var self = this;

        var pageHtml = this.resultPageHtml({
            "class": this.className,
            "showHeader": this.options.name != null,
            "name": this.options.name,
            "showPagination": this.options.showPagination
        });

        if (this.contEl == null) {
            this.contEl = new Element("div", {
                "class": this.className + "-cont",
                "html": pageHtml
            });
        } else {
            this.contEl.empty();
            this.contEl.removeClass("thumbnail-view");
            this.contEl.set("html", pageHtml);
        }

        switch (this.options.view) {
            case Librarian.SearchResult.views.thumbnail:
                this.contEl.addClass("thumbnail-view");
                break;
        }

        if (data != null) {
            this.data = data;
            this.items = [];

            if (this.lastQuery != null) {
                var from = this.lastQuery.options.from;
                this.currentPage = from / Librarian.search.maxResults + 1;
            }

            this.total = data.total;
            this.totalPages = Math.ceil(data.total / Librarian.search.maxResults);

            var resultContEl = this.contEl.getElement("." + this.className + "-items-cont");
            var pageInfoContEl = this.contEl.getElement("." + this.className + "-page-info-cont");
            var paginationContEl = this.contEl.getElement("." + this.className + "-pagination-cont");
            var wrapperEl = this.contEl.getElement("." + this.className);
            var viewAllEl = this.contEl.getElement("." + this.className + "-bucket-view-all");
            var sortContEl = this.contEl.getElement("." + this.className + "-sort-cont");

            if (this.options.name != null) {
                this.contEl.addClass(this.className + "-bucket");
                wrapperEl.addClass(this.className + "-bucket-results");
            }

            if (viewAllEl != null) {
                viewAllEl.addEvent("click", function() {
                    var name = self.options.name;
                    var categoryFiltersEl = $("search-result-category-filter");
                    categoryFiltersEl.getElements("input").set("checked", false);
                    var bucketEl = categoryFiltersEl.getElement("input[value=" + name + "]");
                    bucketEl.click();

                });
            }

            if (data.hits.length > 0) {
                Array.each(data.hits, function (contentInfo, index) {
                    var result = new Librarian.SearchResultItem({
                        data: contentInfo,
                        index: index,
                        view: self.options.view,
                        maxHiglights: self.options.maxHiglights
                    }, self);
                    self.items.push(result);

                    var resultEl = result.render();
                    resultContEl.grab(resultEl);
                });

                if (paginationContEl != null) {
                    var paginationEl = this.renderPagination();
                    paginationContEl.grab(paginationEl);
                }

                var pageInfoEl = this.renderPageInfo();
                pageInfoContEl.grab(pageInfoEl);

                if (this.options.showSort) {
                    var sortEl = this.renderSort();
                    sortContEl.grab(sortEl);
                }
            }
            else {
                resultContEl.set("html", this.emptyResultPageHtml({
                    "class": this.className
                }));
            }
        }

        return this.contEl;
    },

    renderPageInfo: function() {
        var pageInfoHtml = this.pageInfoTemplate({
            currentPage: this.currentPage,
            totalPages: this.totalPages,
            total: (this.total >= 10000 ? "10000+" : this.total) + " " + Librarian.Lang.getPluralString("es_total_result", this.total),
            pagesToDisplay: this.options.pagesToDisplay,
            "class": this.className,
            showPagination: this.options.showPagination
        });


        var pageInfoEl = new Element("div", {
            "class": this.className + "page-info",
            "html": pageInfoHtml
        });

        return pageInfoEl;
    },

    renderPagination: function() {
        var self = this;
        var paginationHtml = this.paginationTemplate({
            currentPage: this.currentPage,
            totalPages: this.totalPages,
            pagesToDisplay: this.options.pagesToDisplay,
            "class": this.className
        });


        var paginationEl = new Element("div", {
            "class": this.className + "pagination",
            "html": paginationHtml
        });

        var pagesEl = paginationEl.getElements("." + this.className + "-page-number");
        pagesEl.addEvent("click", function(e) {
            var targetEl = e.target;
            var pageNumber = parseInt(targetEl.textContent);
            self.goToPage(pageNumber);
        });

        var previousButtonIconEl = paginationEl.getElement("." + this.className + "-to-previous");
        var previousButtonEl = paginationEl.getElement("." + this.className + "-previous");
        if (this.currentPage === 1) {
            previousButtonIconEl.addClass("disabled");
            previousButtonEl.addClass("disabled");
        } else {
            previousButtonIconEl.addEvent("click", function(e) {
                self.goToPage(self.currentPage - 1);
            });
            previousButtonEl.addEvent("click", function(e) {
                self.goToPage(self.currentPage - 1);
            });
        }

        var nextButtonIconEl = paginationEl.getElement("." + this.className + "-to-next");
        var nextButtonEl = paginationEl.getElement("." + this.className + "-next");
        if (this.currentPage === this.totalPages) {
            nextButtonIconEl.addClass("disabled");
            nextButtonEl.addClass("disabled");
        } else {
            nextButtonIconEl.addEvent("click", function(e) {
                self.goToPage(self.currentPage + 1);
            });
            nextButtonEl.addEvent("click", function(e) {
                self.goToPage(self.currentPage + 1);
            });
        }

        return paginationEl;
    },

    renderSort: function () {
        var self = this;
        var sortBy = [];
        var defaultSort = Librarian.elasticSearch.defaultSortType;
        var attributeSort = null;
        if (this.lastQuery != null) {
            attributeSort = this.lastQuery.options.sortAttributeName;
            defaultSort = this.lastQuery.options.sortField;
        }
        Object.each(Librarian.ElasticSearch.querySortField, function (sortValue, key) {
            sortBy.push({
                "label": Librarian.Lang.getString("es_sort_" + key),
                "value": sortValue,
                "selected": sortValue === defaultSort
            });
        });

        if (Librarian.elasticSearch.attributeSort) {
            Array.each(Librarian.elasticSearch.attributeSort, function (attr) {
                sortBy.push({
                    "label": attr ,
                    "value": Librarian.ElasticSearch.attributeSort,
                    "selected": Librarian.ElasticSearch.attributeSort === defaultSort && attributeSort === attr
                });
            });
        }

        var sortHtml = this.sortTemplate({
            "sort": sortBy,
            "class": this.className
        });

        var sortEl = new Element("div", {
            "class": this.className + "-sort",
            "html": sortHtml
        });

        var sortInputEl = sortEl.getElement("." + this.className + "-sort-input");
        sortInputEl.addEvent("change", function () {
            var sortField = parseInt(this.value);
            var sortDescending;
  
            switch(sortField) {
                case Librarian.ElasticSearch.querySortField.name:
                    sortDescending = false;
                    break;
                default:
                    sortDescending = true;
                    break;
            }
            
            Librarian.ElasticSearch.sortField = sortField;
            Librarian.ElasticSearch.sortDescending = sortDescending;

            var searchOptions = self.lastQuery;
            searchOptions.options.sortField = sortField;
            searchOptions.options.sortDescending = sortDescending;

            var sortPreference = {
                sortField: sortField,
                sortDescending: sortDescending,
            };

            if (Librarian.ElasticSearch.sortField == Librarian.ElasticSearch.attributeSort) {
                var selectedEl = this.getSelected();
                var label = selectedEl.get("text")[0];
                Librarian.ElasticSearch.attributeSortName = label;
                searchOptions.options.sortAttributeName = label;
                sortPreference.sortAttributeName = label;
            }
            else {
                Librarian.ElasticSearch.attributeSortName = null;
                searchOptions.options.sortAttributeName = null;
                sortPreference.sortAttributeName = null;
            }

            Librarian.ElasticSearch.setSearchPreference(sortPreference);

            self.search(searchOptions);
        });

        return sortEl;
    },

    goToPage: function (pageNumber) {
        if (pageNumber === this.currentPage) {
            return;
        }

        var mainElement = $("mainPanel_pad");
        mainElement.scrollTop = 0;

        var from = Librarian.search.maxResults * (pageNumber - 1);
        var searchOptions = this.lastQuery;
        searchOptions.options.from = from;

        this.search(searchOptions);
    },

    search: function (searchOptions) {
        var self = this;
        var es = new Librarian.ElasticSearch({
            loadComplete: function (results) {
                self.render(results);
            }
        });
        es.searchOptions = searchOptions;
        this.lastQuery = searchOptions;

        es.search();
    },

    renderTypeFilters: function () {
        var self = this;
        var types = Librarian.SearchOptions.typeFilters;

        var typeFilterHtml = this.typeFilterTemplate({
            "types": types,
            "class": this.className + "-type-filter"
        });

        var typeFilterEl = new Element("div", {
            "class": this.className + "-type-filter",
            "html": typeFilterHtml
        });

        var searchOptions = this.lastQuery;
        var selectedTypeEl;
        if (searchOptions.typeFilter != null) {
            selectedTypeEl = typeFilterEl.getElement("#" + searchOptions.typeFilter);
        } else {
            selectedTypeEl = typeFilterEl.getElement("#view_bar_all");
        }

        if (selectedTypeEl) {
            selectedTypeEl.addClass("selected");
        }

        var typesEl = typeFilterEl.getElements("." + this.className + "-type-filter-type");
        typesEl.addEvent("click", function(e) {
            var id = this.id;
            var typeInfo = Librarian.SearchResult.typeFilters[id];

            var searchOptions = self.lastQuery;
            searchOptions.typeFilter = id;
            searchOptions.queryContentType = typeInfo.elasticQueryContentType;

            searchOptions.filters = searchOptions.filters || new Librarian.ElasticSearch.ElasticSearchQueryFilter();
            searchOptions.filters.members.fileSubTypes = null;

            if (typeInfo.fileSubTypes != null) {
                searchOptions.filters.set("fileSubTypes", typeInfo.fileSubTypes);
            }

            // Reset pagination
            searchOptions.options.from = 0;
            self.currentPage = 1;

            var es = new Librarian.ElasticSearch({
                loadComplete: function (result) {
                    self.render(result);
                }
            });
            es.searchOptions = searchOptions;
            self.lastQuery = es.searchOptions;

            es.search();
        });

        return typeFilterEl;
    },

    getItem: function(index) {
        return this.items[index];
    },

    updateCartCheckBoxes: function() {
        Array.each(this.items, function(item) {
            item.updateCartState();
        });
    }
})
    .extend({
        groupResultCount: 5,

        views: {
            "thumbnail": 1
        },

        resultPageHtml: Handlebars.compile("\
        <div class='{{class}}-header'> \
            <div id='{{class}}-help-cont'> \
            </div> \
            <span class='{{class}}-header-title'>Search Results</span> \
            <div class='{{class}}-view-cont'> \
                <input aria-label='view' type='checkbox' id='{{class}}-view' value='{{thumbnailView}}' {{#if isThumbnailView}}checked{{/if}} /> \
                <label for='{{class}}-view'></label> \
            </div> \
        </div>\
        <div id='{{class}}-category-filter'></div>\
        <div class='{{class}}-type-filter-cont'></div>\
        <div class='{{class}}-results'></div> \
    "),

        emptyResultPageHtml: Handlebars.compile("\
        <div class='{{class}}-no-results'>No Results Found.</div>\
    "),

        suggestionsHtml: Handlebars.compile("\
        <div class='{{class}}'>Did you mean \
        {{#each suggestions}} \
            {{#if @index }}<span>,</span>{{/if}}\
            <a class='{{../class}}-term'>{{this}}</a> \
        {{/each}} \
        ?</div>"),

        initSearchPage: function () {
            var searchPageEl = $("search-result-page");
            if (searchPageEl) {
                searchPageEl.set("html", Librarian.SearchResult.resultPageHtml({
                    "class": "search-result",
                    "thumbnailView": Librarian.SearchResult.views.thumbnail,
                    "isThumbnailView": Librarian.elasticSearch.resultsView == Librarian.SearchResult.views.thumbnail
                }));

                var toggleView = $("search-result-view");
                toggleView.addEvent("change", function () {
                    var activeView = Librarian.SearchResult.getActiveView();
                    if (Librarian.SearchResult.resultViews != null) {
                        Array.each(Librarian.SearchResult.resultViews, function (resultView) {
                            resultView.options.view = activeView;
                            resultView.render(resultView.data);
                        });
                    }
                });
            }

            //Setup help link if enabled
            var helpEl = $("search-result-help-cont");
            if (helpEl && Librarian.search.displayHelp.enabled) {
                helpEl.set("html", Librarian.search.displayHelp.html);
                var linkEl = $("search-help-link");
                if (linkEl) {
                    linkEl.addOnClick(function () {
                        Librarian.PreviewWindow.openPreviewWindow({ filename: Librarian.search.displayHelp.fileName });
                    });
                }
            }

            Librarian.searchPanel.fireEvent("searchPageLoaded");
        },

        getActiveView: function () {
            var isThumbnailView = $("search-result-view") && $("search-result-view").get("checked");

            return isThumbnailView ? parseInt($("search-result-view").get("value")) : -1;

        },

        getSuggestion: function (suggestions, searchOptions) {
            var allSuggestions = [];

            if (Librarian.SearchOptions.searchOptions && Librarian.SearchOptions.searchOptions.suggester) {
                var type = Librarian.SearchOptions.searchOptions.suggester.suggestionType;
                var currentSuggestion = null;
                if (type == "phrase" || type == "all") {
                    var phraseSuggestion = this.getPhraseSuggestion(suggestions);
                    if (phraseSuggestion != null) {
                        currentSuggestion = phraseSuggestion;
                        allSuggestions.push(phraseSuggestion);
                    }
                }

                if (type == "term" || type == "all") {
                    var termSuggestion = this.getTermSuggestion(suggestions, searchOptions);
                    if (termSuggestion != null && currentSuggestion != termSuggestion) {
                        allSuggestions.push(termSuggestion);
                    }
                }
            }

            return allSuggestions;
        },

        findMaxSuggestion: function (suggestions) {
            var topSuggestion = {
                score: 0
            };

            Array.each(suggestions, function (suggestion) {
                if (suggestion.score > topSuggestion.score) {
                    topSuggestion = suggestion;
                }
            });

            return topSuggestion;
        },

        getPhraseSuggestion: function (suggestions) {
            var self = this;
            var suggestion = {
                score: 0
            };

            if (suggestions != null) {
                if (suggestions.phrases.length > 0) {
                    Array.each(suggestions.phrases, function (phrase) {
                        var phraseSuggestion = self.findMaxSuggestion(phrase.phraseSuggestions);

                        if (phraseSuggestion != null && phraseSuggestion.score > suggestion.score) {
                            suggestion = phraseSuggestion;
                        }
                    });
                }
            }

            return suggestion.text;
        },

        getTermSuggestion: function (suggestions, searchOptions) {
            var suggestionText = null;

            if (suggestions != null && suggestions.terms != null && searchOptions.searchTerms) {
                var originalQuery = searchOptions.searchTerms.query.toLowerCase();
                var query = originalQuery;
                Array.each(suggestions.terms, function (term) {
                    var termSuggestion = term.termSuggestions[0];

                    if (termSuggestion != null) {
                        query = query.replace(term.text, termSuggestion.text);
                    }
                });

                if (originalQuery != query) {
                    suggestionText = query;
                }
            }

            return suggestionText;
        },

        renderSuggestions: function (resultsEl, suggestions, searchOptions) {
            var allSuggestions = Librarian.SearchResult.getSuggestion(suggestions, searchOptions);

            if (allSuggestions != null && allSuggestions.length > 0) {
                var className = "search-suggestion";
                var suggestionEl = new Element("div", {
                    "html": Librarian.SearchResult.suggestionsHtml({
                        "class": className,
                        "suggestions": allSuggestions
                    })
                });

                var suggestionTermEl = suggestionEl.getElement("." + className + "-term");
                suggestionTermEl.addEvent("click", function (e) {
                    var value = this.text;
                    Library.quickSearch(value);
                });

                resultsEl.grab(suggestionEl);
            }
        },

        prepSearchPage: function (results, searchOptions, suggestions) {
            Library.cleanSearchPage();
            var searchOptionsName = Librarian.Utils.getHashByName("searchOptions");

            if (typeof searchOptionsName == "string") {
                if (Librarian.searchPanel.sourceName != searchOptionsName) {
                    var loadCustomSearch = function () {
                        Librarian.searchPanel.fetchSearchOptions(searchOptionsName);
                    };

                    if (Librarian.searchPanel.loaded) {
                        loadCustomSearch();
                    }
                    else {
                        Librarian.searchPanel.addEvent("loaded:once", loadCustomSearch);
                    }
                }
            }
            else {
                if (!Librarian.searchPanel.isDefaultSearchOption()) {
                    Librarian.searchPanel.fetchSearchOptions();
                }
            }

            var resultsPageEl = $("search-result-page");
            var resultsEl;
            if (resultsPageEl) {
                resultsEl = resultsPageEl.getElement(".search-result-results");
                resultsEl.empty();
            }

            var activeView = Librarian.SearchResult.getActiveView();
            Librarian.SearchResult.resultViews = [];

            var searchSuggestions = suggestions || (results != null ? results.suggestions : null);
            if (searchSuggestions != null) {
                Librarian.SearchResult.renderSuggestions(resultsEl, searchSuggestions, searchOptions);
            }

            if (typeOf(results) === "array") {
                var totalResults = 0;
                Array.each(results, function (result) {
                    var searchResults = result.results || Librarian.ElasticSearch.searchResults;
                    var searchOptions = result.searchOptions;

                    if (searchResults.total > 0) {
                        totalResults = totalResults + searchResults.total;
                        var resultsView = new Librarian.SearchResult({
                            name: result.label,
                            showPagination: false,
                            view: activeView,
                            showSort: false
                        });
                        resultsView.lastQuery = searchOptions;
                        Librarian.SearchResult.resultViews.push(resultsView);
                        var resultsViewEl = resultsView.render(searchResults);
                        resultsEl.grab(resultsViewEl);
                    }
                });

                if (totalResults === 0) {
                    var noResultsEl = new Element("div", {
                        "html": Librarian.SearchResult.emptyResultPageHtml({
                            "class": "search-result"
                        })
                    });
                    resultsEl.grab(noResultsEl);
                }
            } else {
                var resultsView = new Librarian.SearchResult({
                    view: activeView
                });
                resultsView.lastQuery = searchOptions;
                Librarian.SearchResult.resultViews.push(resultsView);
                var resultsViewEl = resultsView.render(results);
                if (resultsEl && resultsViewEl)
                    resultsEl.grab(resultsViewEl);
            }

            tileList.reset();
            $("pageheader").hide();

            if (resultsPageEl)
                resultsPageEl.show();
        },

        cleanUpSearchTerm: function (term) {
            if (!term) {
                return term;
            }
            term = term.toLowerCase();
            term = term.replace(/["()+-”]/g, '');
            term = term.trim();

            return term;

        }
});

